import { getServerApi } from '@/gql';
import { Permit } from '@/gql/graph/__generated__/request';
import user from '@/stores/user';
import { useState } from 'react';

export interface UseSetLevelPermitResult {
    permit: Permit | null;
    loading: boolean;
    error: Error | null;
    getSetLevelPermit: () => Promise<Permit | null>;
}

export const useSetLevelPermit = (tokenId: number): UseSetLevelPermitResult => {
    const [permit, setPermit] = useState<Permit | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getSetLevelPermit = async () => {
        if (!tokenId || !userId) {
            setPermit(null);
            return null;
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.setLevelPermit({
                tokenId: tokenId,
            });
            if (response?.setLevelPermit !== undefined) {
                setPermit(response.setLevelPermit);
                return response.setLevelPermit;
            } else {
                setPermit(null);
                return null;
            }
        } catch (err) {
            console.error('Failed to fetch permit:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch permit'),
            );
            setPermit(null);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        permit,
        loading,
        error,
        getSetLevelPermit,
    };
};
